/**
 * Edge Path Constants
 * 
 * Shared constants for edge routing calculations
 * 
 * IMPORTANT: GAP should match the layout engine's gap value
 */

// This should match layoutEngine.js GAP values
export const GAP = 40;

export const NODE_WIDTH = 290;
export const NODE_HEIGHT = 120;
export const CORNER_RADIUS = 8;
export const CLEARANCE = Math.max(10, GAP / 4); // Clearance scales with gap, minimum 10px

/** Extra padding beyond CLEARANCE so routed edges do not skim node frames (obstacle inflation only). */
export const ROUTING_LINE_MARGIN = 6;
/** Full half-expansion from each node rect edge for routing / segment collision (not layout). */
export const ROUTING_OBSTACLE_INFLATION = CLEARANCE + ROUTING_LINE_MARGIN;

// Minimum perpendicular distance from node before any turn is allowed
// Edges must travel straight for at least this distance before making a right angle
export const MIN_PERPENDICULAR_DISTANCE = 12;